// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"e098621a","703":"f07449ba","787":"9a49ad55"}[chunkId] + ".chunk.js";
};